
<v-menu
  v-model="menu"
  :close-on-content-click="false"
  offset-y
  bottom
  left
  :min-width="menuWidth"
  :max-width="menuWidth"
  content-class="product-switcher-menu"
>
  <template #activator="{ on, attrs }">
    <button
      class="product-switcher-btn"
      :class="{ 'product-switcher-btn--active': menu }"
      v-bind="attrs"
      v-on="on"
    >
      <lucide-icon name="Grid3x3" :size="20" />
    </button>
  </template>

  <v-card class="product-switcher-card">
    <v-card-text class="pa-0">
      <div class="portal-grid">
        <div
          v-for="(product, index) in products"
          :key="product.name"
          :ref="index === 0 ? 'firstProductCard' : undefined"
          class="portal-card"
          :class="{ 'portal-card--disabled': product.disabled }"
          :tabindex="product.disabled ? -1 : 0"
          role="button"
          :aria-label="`Navigate to ${product.name}`"
          @click="handleProductClick(product)"
          @keydown.enter="handleProductClick(product)"
          @keydown.space.prevent="handleProductClick(product)"
        >
          <div class="portal-card-content">
            <div class="portal-icon-wrapper">
              <lucide-icon
                :name="product.icon"
                :size="28"
                class="portal-icon"
              />
            </div>
            <div class="portal-name">
              {{ product.name }}
            </div>
            <div v-if="product.description" class="portal-description">
              {{ product.description }}
            </div>
            <div class="portal-actions">
              <lucide-icon name="ExternalLink" :size="18" class="portal-action-icon" />
              <lucide-icon name="ChevronRight" :size="18" class="portal-action-icon" />
            </div>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</v-menu>
